export const CROSS_APP_SUPPORT_ARTICLE_URL = 'https://adoptsupport.pendo.io/hc/en-us/articles/6758475990939';
